import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trCommon from './locales/tr/common.json';
import trAuth from './locales/tr/auth.json';
import trSettings from './locales/tr/settings.json';
import trNav from './locales/tr/nav.json';
import trEnum from './locales/tr/enum.json';
import trDashboard from './locales/tr/dashboard.json';
import trPlatform from './locales/tr/platform.json';
import trComponents from './locales/tr/components.json';
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enSettings from './locales/en/settings.json';
import enNav from './locales/en/nav.json';
import enEnum from './locales/en/enum.json';
import enDashboard from './locales/en/dashboard.json';
import enPlatform from './locales/en/platform.json';
import enComponents from './locales/en/components.json';

/**
 * i18n altyapısı — Custel web-admin.
 *
 * Karar (Faz 4): UI metni TR/EN arasında çalışma-zamanında (restart'sız) değişebilir.
 * Varsayılan + fallback **Türkçe** (ürün TR-first). EN ikincil.
 *
 * ÖNEMLİ — Sayı/para/tarih FORMATI her zaman TR kalır (1.234,56 ₺, 13.05.2026).
 * Bu i18n katmanı yalnız UI metnini çevirir; formatlama hâlâ `@custel/turkish`
 * (`formatTL`, `formatRelative`, `formatAbsolute`) üzerinden yapılır. Locale spec:
 * `handoff/locale-tr.md`.
 *
 * Namespace stratejisi: `common` (paylaşılan: butonlar, durumlar, navigasyon),
 * `auth`, `settings`. Yeni ekran grubu → yeni namespace. Anahtar konvansiyonu
 * iOS ile ortak: `<alan>.<ekran>.<eleman>` (örn. `auth.login.title`).
 */

export const SUPPORTED_LANGUAGES = ['tr', 'en'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  tr: 'Türkçe',
  en: 'English',
};

/** localStorage anahtarı — detector + manuel toggle aynı anahtarı paylaşır. */
export const LANGUAGE_STORAGE_KEY = 'custel.lang';

export const defaultNS = 'common';

export const resources = {
  tr: {
    common: trCommon,
    auth: trAuth,
    settings: trSettings,
    nav: trNav,
    enum: trEnum,
    dashboard: trDashboard,
    platform: trPlatform,
    components: trComponents,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    settings: enSettings,
    nav: enNav,
    enum: enEnum,
    dashboard: enDashboard,
    platform: enPlatform,
    components: enComponents,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    defaultNS,
    ns: ['common', 'auth', 'settings', 'nav', 'enum', 'dashboard', 'platform', 'components'],
    interpolation: {
      escapeValue: false, // React zaten XSS-safe
    },
    detection: {
      // Önce kullanıcı seçimi (localStorage), sonra tarayıcı dili.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    // EN eksik anahtarda TR'ye düş; konsola gürültü yapma (geçiş dönemi).
    returnNull: false,
    saveMissing: false,
  });

export default i18n;
